import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Appointment, Doctor } from '@app/_models';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AppointmentService {
    private apptSubject: BehaviorSubject<any>;
    public appt$: Observable<any>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        let info=JSON.parse(localStorage.getItem('apptInfo'));
        this.apptSubject = new BehaviorSubject<any>(info);
        this.appt$ = this.apptSubject.asObservable();
    }

    public get apptInfo(): any {
        return this.apptSubject.value;
    }
    getDoctorSchedule(postData){
        return this.http.post<any>(`${environment.apiUrl}appointments/check-availability`,postData);
    }
    bookAppointment(postData:Appointment){
        return this.http.post<any>(`${environment.apiUrl}appointments/book-appointment`,postData)
        .pipe(map(appt => {
            return appt;
        }));
    }
    createPayOrderAppointment(postData:Appointment){
        return this.http.post<any>(`${environment.apiUrl}appointments/create-appointment-order`,postData)
        .pipe(map(appt => {
            return appt;
        }));
    }
    razorPayPayment(orderID,postData){
        return this.http.post<any>(`${environment.apiUrl}appointments/verify-razorpay-payment/`+orderID,postData)
        .pipe(map(appt => {
            return appt;
        }));
    }
    PayUPayment(orderID,postData){
        return this.http.post<any>(`${environment.apiUrl}appointments/verify-payment/`+orderID,postData)
        .pipe(map(appt => {
            return appt;
        }));
    }
    cancelAppointment(apptID,reason){
        return this.http.delete<any>(`${environment.apiUrl}appointments/cancel-appointment/`+apptID+`/`+reason)
        .pipe(map(appt => {
            return appt;
        }));
    }
    setAppointmentInfo(apptInfo)
    {
        localStorage.setItem('apptInfo', JSON.stringify(apptInfo));
        this.apptSubject.next(apptInfo);
    }
    
 
   
}